import { render, staticRenderFns } from "./another-person-business-card.vue?vue&type=template&id=c59e4bfa&scoped=true&lang=pug&"
import script from "./another-person-business-card.vue?vue&type=script&lang=js&"
export * from "./another-person-business-card.vue?vue&type=script&lang=js&"
import style0 from "./another-person-business-card.vue?vue&type=style&index=0&id=c59e4bfa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c59e4bfa",
  null
  
)

export default component.exports